module.exports = __webpack_public_path__ + "entry-150bfe9b/app-store-badge-de-9fe34596af8c52c30cb26829e9d959fe.svg";